export enum CustomerType {
	Final,
	Delivery,
}
